import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';
import Row from '@common/Row';
import RichText from '@common/RichText';
import Heading from '@common/Heading';

const TabbedItem = ({ data }) => {
  const {
    title,
    images,
    text,
    imagePosition
  } = data;
  return (
    <Row className={clsx('py-4 px-3 pb-0', {'flex-reverse': imagePosition === 'Right'})}>
      <div className={`mx-auto col-5 col-lg-3 p-2`}>
        {images && images.map(image => (
          <Img key={image.id} className={`my-auto`} image={image.gatsbyImageData} file={image.file} />
        ))}
      </div>
      <div className={'col-lg-9 ps-lg-4 py-2 d-flex flex-column justify-content-between'}>
        <Heading type='h3' className='mb-2 h4'>{title}</Heading>
        <RichText
          json={text}
          h2={`mb-2`}
          h3={`mb-2 h4`}
          h4={`mb-2`}
          p={`mb-3 fs-20`}
          ul={`w-100 justify-content-between`}
          li={`pe-1`}
        />
      </div>
    </Row>
  )
}

export default TabbedItem
